
<template>
	<div id="app">
        
		<transition name="fade"
		            mode="out-in">
			<router-view></router-view>
		</transition>
        
	</div>
</template>


<script>
export default {
    name: 'App',
    watch: {
        '$route': function(to,from){
    　      document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
        }
    },
    data () {
        return {}
    }

}
</script>

<style  src="./styles/App.css"></style>
